module.exports = __webpack_public_path__ + "media/whats_your_status_series_summer_must_dos/preparing-for-college-summer-must-dos-ecf5ead2.jpg";